import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashGet from 'lodash/fp/get';

import typeCheck from 'common/util/typeCheck';
import parseJSON from 'common/util/parseJSON';

import safeLocalStorage from 'client/lib/safeLocalStorage';
import branch from 'client/core/branch';

import AgentActions from 'client/actions/Agent';

import SrTourListingComment from 'client/components/SrTourListingComment';

@branch()
class SrAgentTourListingQuestions extends Component {
  static propTypes = {
    setButtonsDisabled: PropTypes.func.isRequired,
    tourId: PropTypes.number.isRequired,
    listingId: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    const tourGuideReportsByTourIdFromLocalStorage = safeLocalStorage.getItem('tourGuideReportsByTourId');

    const tourGuideReportEditsByTourId = (
      parseJSON(tourGuideReportsByTourIdFromLocalStorage)
      || props.tourGuideReportsByTourId
    );

    this.state = {
      tourGuideReportEditsByTourId: tourGuideReportEditsByTourId,
      autofocusIndex: null,
    };
  }

  componentDidMount() {
    const { setButtonsDisabled } = this.props;
    const { buttonsDisabled } = this._getCommentFieldsMetadata({ state: this.state });
    setButtonsDisabled(buttonsDisabled);
  }

  // HACK(@d-oliveros): This file has no salvation. Hacking my way up to SrFormikField-esque behaviors.
  _getCommentFieldsMetadata = ({ state }) => {
    const { tourId, listingId } = this.props;
    const { tourGuideReportEditsByTourId } = state;

    const commentAnythingCanBeImproved = lodashGet(
      `${tourId}.agentCommentsByListingId.${listingId}`,
      tourGuideReportEditsByTourId,
    );

    const commentRenterHasNegativeComments = lodashGet(
      `${tourId}.negativeRenterCommentsByListingId.${listingId}`,
      tourGuideReportEditsByTourId,
    );

    const commentAnythingCanBeImprovedIsValid = (commentAnythingCanBeImproved || '').length >= 30;
    const commentRenterHasNegativeCommentsIsValid = (commentRenterHasNegativeComments || '').length >= 30;
    const buttonsDisabled = (
      !commentAnythingCanBeImprovedIsValid
      || !commentRenterHasNegativeCommentsIsValid
    );

    return {
      commentAnythingCanBeImproved,
      commentRenterHasNegativeComments,
      commentAnythingCanBeImprovedIsValid,
      commentRenterHasNegativeCommentsIsValid,
      buttonsDisabled,
    };
  }

  _onTourRenterQuestionChange = ({ tourId, listingId, question, index }) => {
    typeCheck('question::String', question);
    const currentTourQuestions = this.state.tourGuideReportEditsByTourId[tourId].renterQuestionsByListingId;
    const currentListingQuestions = [...currentTourQuestions[listingId]];
    currentListingQuestions[index] = question;

    const tourGuideReportEditsByTourId = {
      ...this.state.tourGuideReportEditsByTourId,
      [tourId]: {
        ...this.state.tourGuideReportEditsByTourId[tourId],
        renterQuestionsByListingId: {
          ...currentTourQuestions,
          [listingId]: currentListingQuestions,
        },
      },
    };

    this.setState({
      tourGuideReportEditsByTourId,
    });

    this.props.dispatch(AgentActions.setTourGuideReportValues, {
      tourGuideReportsByTourId: tourGuideReportEditsByTourId,
    });
  }

  _addRenterQuestion = (event, tourId, listingId) => {
    event.preventDefault();

    const currentTourQuestions = this.state.tourGuideReportEditsByTourId[tourId].renterQuestionsByListingId;
    const currentListingQuestions = currentTourQuestions[listingId];
    const index = currentListingQuestions.length;

    const tourGuideReportEditsByTourId = {
      ...this.state.tourGuideReportEditsByTourId,
      [tourId]: {
        ...this.state.tourGuideReportEditsByTourId[tourId],
        renterQuestionsByListingId: {
          ...currentTourQuestions,
          [listingId]: [...currentListingQuestions, ''],
        },
      },
    };

    this.setState({
      tourGuideReportEditsByTourId,
      autofocusIndex: `${tourId}-${listingId}-${index}`,
    });

    this.props.dispatch(AgentActions.setTourGuideReportValues, {
      tourGuideReportsByTourId: tourGuideReportEditsByTourId,
    });
  }

  _onCommentChange = (agentCommentsByListingId, comment) => {
    const { tourId, listingId, setButtonsDisabled } = this.props;
    const { tourGuideReportEditsByTourId } = this.state;

    const newState = {
      tourGuideReportEditsByTourId: {
        ...tourGuideReportEditsByTourId,
        [tourId]: {
          ...tourGuideReportEditsByTourId[tourId],
          [agentCommentsByListingId]: {
            ...(lodashGet(`${tourId}.${agentCommentsByListingId}`, tourGuideReportEditsByTourId) || {}),
            [listingId]: comment,
          },
        },
      },
    };

    const { buttonsDisabled } = this._getCommentFieldsMetadata({ state: newState });

    this.setState(newState);
    setButtonsDisabled(buttonsDisabled);
    this.props.dispatch(AgentActions.setTourGuideReportValues, {
      tourGuideReportsByTourId: newState.tourGuideReportEditsByTourId,
    });
  }

  render() {
    const { tourId, listingId } = this.props;

    const {
      tourGuideReportEditsByTourId,
      autofocusIndex,
    } = this.state;

    if (!tourGuideReportEditsByTourId || !tourGuideReportEditsByTourId[tourId]) {
      return null;
    }

    const tourRenterQuestions = tourGuideReportEditsByTourId[tourId].renterQuestionsByListingId[listingId] || ['']; // eslint-disable-line max-len
    const firstQuestion = tourRenterQuestions[0];
    const additionalQuestions = tourRenterQuestions.slice(1);

    const {
      commentAnythingCanBeImproved,
      commentRenterHasNegativeComments,
    } = this._getCommentFieldsMetadata({ state: this.state });

    return (
      <div className='sectionContainer notesContainer questions'>
        <SrTourListingComment
          title={
            <span>
              <span>
                Renter's positive property feedback&nbsp;
              </span>
              <span style={{ fontWeight: '400' }}>
                (30 character minimum)
              </span>
            </span>
          }
          placeholder='Example: I saw several cockroaches in the foyer, consider cleaning.'
          tourGuideReportEditsByTourIdKey='agentCommentsByListingId'
          value={commentAnythingCanBeImproved}
          onChange={this._onCommentChange}
        />
        <SrTourListingComment
          title={
            <span>
              <span>
                Renter's negative property feedback&nbsp;
              </span>
              <span style={{ fontWeight: '400' }}>
                (30 character minimum)
              </span>
            </span>
          }
          placeholder='Example: The backyard was extremely muddy, which will track in dirt with my dog.'
          tourGuideReportEditsByTourIdKey='negativeRenterCommentsByListingId'
          value={commentRenterHasNegativeComments}
          onChange={this._onCommentChange}
        />
        <div>
          <span className='headline'>Does the renter have any questions for us or the landlord?</span>
          <div className='sectionContent textInput'>
            <textarea
              key={`${tourId}-${listingId}-first`}
              className='sr-textarea renter-question'
              placeholder='Is the landlord fine with their 65lb dog?'
              value={firstQuestion}
              onChange={(event) => this._onTourRenterQuestionChange({
                tourId,
                listingId,
                question: event.target.value,
                index: 0,
              })}
            />
            {additionalQuestions.map((question, index) => (
              <textarea
                key={`${tourId}-${listingId}-${index}`} // eslint-disable-line react/no-array-index-key
                className='sr-textarea'
                placeholder='Write a question...'
                value={question}
                autoFocus={autofocusIndex === `${tourId}-${listingId}-${index + 1}`} // eslint-disable-line jsx-a11y/no-autofocus
                onChange={(event) => this._onTourRenterQuestionChange({
                  tourId,
                  listingId,
                  question: event.target.value,
                  index: index + 1,
                })}
              />
            ))}
            <span
              className='input add-question'
              onClick={(event) => this._addRenterQuestion(event, tourId, listingId)}
            >
              + add question
            </span>
          </div>
        </div>
      </div>
    );
  }
}

SrAgentTourListingQuestions.displayName = 'SrAgentTourListingQuestions';

export default SrAgentTourListingQuestions;
